/** A municipal staff member who can be part of an internal team. */
export interface StaffMember {
  id: string
  name: string
  role: string
}

/** Internal team used as an audience criterion ("Qui") for notices. */
export interface InternalTeam {
  id: string
  name: string
  memberIds: string[]
}

/** Staff directory (sample people — the first five are the app accounts). */
export const STAFF_MEMBERS: StaffMember[] = [
  { id: 'u-assaad', name: 'Doreen Assaad', role: 'Mairesse' },
  { id: 'u-quintal', name: 'Stéphanie Quintal', role: 'Conseillère municipale · District 4' },
  { id: 'u-gaudette', name: 'Christian Gaudette', role: 'Conseiller municipal · District 1' },
  { id: 'u-benedetti', name: 'Guy Benedetti', role: 'Directeur général' },
  { id: 'u-brunelle', name: 'Martin Brunelle', role: 'Directeur principal · Administration et efficience' },
  { id: 'u-tremblay', name: 'Julie Tremblay', role: 'Conseillère en communication' },
  { id: 'u-nguyen', name: 'Minh Nguyen', role: 'Coordonnateur des médias sociaux' },
  { id: 'u-roy', name: 'Catherine Roy', role: 'Cheffe de division · Communications' },
  { id: 'u-lavoie', name: 'Patrick Lavoie', role: 'Contremaître · Travaux publics' },
  { id: 'u-haddad', name: 'Karim Haddad', role: 'Surintendant · Voirie' },
  { id: 'u-gagnon', name: 'Sophie Gagnon', role: 'Ingénieure · Génie' },
  { id: 'u-bouchard', name: 'Marc Bouchard', role: 'Chargé de projets · Génie' },
  { id: 'u-pelletier', name: 'Isabelle Pelletier', role: 'Agente · Services Brossard' },
  { id: 'u-morin', name: 'Olivier Morin', role: 'Agent · Services Brossard' },
  { id: 'u-cote', name: 'Nathalie Côté', role: 'Superviseure · Services Brossard' },
  { id: 'u-fortin', name: 'Luc Fortin', role: 'Chef aux opérations · Sécurité incendie' },
  { id: 'u-dubois', name: 'Amélie Dubois', role: 'Coordonnatrice · Mesures d’urgence' },
  { id: 'u-leblanc', name: 'Samuel Leblanc', role: 'Régisseur · Loisirs' },
]

export const INITIAL_INTERNAL_TEAMS: InternalTeam[] = [
  { id: 'conseil', name: 'Conseil municipal', memberIds: ['u-assaad', 'u-quintal', 'u-gaudette'] },
  { id: 'direction', name: 'Direction générale', memberIds: ['u-benedetti', 'u-brunelle'] },
  { id: 'communications', name: 'Communications', memberIds: ['u-roy', 'u-tremblay', 'u-nguyen'] },
  { id: 'travaux', name: 'Travaux publics', memberIds: ['u-lavoie', 'u-haddad'] },
  { id: 'genie', name: 'Génie', memberIds: ['u-gagnon', 'u-bouchard'] },
  {
    id: 'services-brossard',
    name: 'Services Brossard',
    memberIds: ['u-cote', 'u-pelletier', 'u-morin'],
  },
  { id: 'urgence', name: 'Cellule de mesures d’urgence', memberIds: ['u-fortin', 'u-dubois', 'u-benedetti'] },
]
